export const BRAND_DOMAIN = 'pasajesbaratos.com';
export const BRAND_NAME = 'Pasajes Baratos';